import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Building2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * OnboardingDecision - Owner-first flow
 * Shown only for non-owners with no_access (e.g. direct signup without invite).
 * Owners with 0 properties are routed to /owner/properties empty state.
 */
const OnboardingDecision = () => {
  const navigate = useNavigate();
  const { profile } = useAuth();
  const firstName = profile?.first_name?.trim() || (profile?.full_name?.trim() ?? "").split(" ")[0] || null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl mb-2">
            Welcome{firstName ? `, ${firstName}` : ""}!
          </CardTitle>
          <CardDescription className="text-base">
            Create a workspace to manage your properties and cleaning tasks
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Card className="border-2 hover:border-primary transition-colors cursor-pointer">
            <CardContent className="p-6">
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center">
                  <Building2 className="h-8 w-8 text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Create & Manage Tasks</h3>
                  <p className="text-sm text-muted-foreground mb-4">
                    Set up your property and start managing cleaning tasks
                  </p>
                </div>
                <Button
                  onClick={() => navigate("/properties/new")}
                  className="w-full"
                  size="lg"
                >
                  Get Started
                </Button>
              </div>
            </CardContent>
          </Card>
          <div className="rounded-lg border border-muted bg-muted/30 p-4 text-center space-y-1">
            <p className="text-sm font-medium text-foreground">
              Are you waiting for an invite link from a property owner?
            </p>
            <p className="text-sm text-muted-foreground">
              Check your email or let them know to resend the invite link. You can close the app and come back once you have the link.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OnboardingDecision;
